<div style="color: black; position: relative; left: 950px;">
    <h2>Tu reporte ha sido enviado exitosamente</h2>
    <span>Gracias por utilizar nuestros servicios</span><br>
    <button (click)="continuar()">Continuar</button>
</div>